module.exports = __webpack_public_path__ + "static/media/arrow-green.a64bdd3e.svg";